import React from 'react';
import type { VersionHistoryEntry } from '../../types/playbook.types';

interface DiffVersionSelectorProps {
  versions: VersionHistoryEntry[];
  baseVersionId: string | null;
  loading: boolean;
  onSelectVersion: (versionId: string) => void;
}

const DiffVersionSelector: React.FC<DiffVersionSelectorProps> = ({ versions, baseVersionId, loading, onSelectVersion }) => {
  if (versions.length === 0) {
    return (
      <div className="rounded-lg border border-violet-200 dark:border-violet-700 bg-violet-50/30 dark:bg-violet-900/10 px-3 py-2 text-xs text-violet-600 dark:text-violet-400">
        {loading ? 'Loading versions...' : 'No other versions available to compare against.'}
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-violet-200 dark:border-violet-700 bg-violet-50/30 dark:bg-violet-900/10 px-3 py-2">
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-semibold text-violet-600 dark:text-violet-400 uppercase">Compare against:</span>
        {versions.map((v) => (
          <button
            key={v.id}
            type="button"
            onClick={() => onSelectVersion(v.id)}
            disabled={loading}
            className={`rounded-md px-2 py-0.5 text-[10px] font-medium transition-colors ${
              baseVersionId === v.id
                ? 'bg-violet-600 text-white'
                : 'border border-violet-300 text-violet-600 hover:bg-violet-100 dark:border-violet-600 dark:text-violet-400 dark:hover:bg-violet-900/30'
            } ${loading ? 'opacity-50' : ''}`}
          >
            v{v.version}
            <span className="ml-1 text-[8px] opacity-70">{v.lifecycle}</span>
          </button>
        ))}
        {loading && (
          <div className="h-3 w-3 animate-spin rounded-full border-2 border-violet-500 border-t-transparent" />
        )}
      </div>
    </div>
  );
};

export default DiffVersionSelector;
